import swiperUtil from '../utils/swiper-util';

export default (node) => {
  /**
   * Data + elements
   */
  let swiperEl = null;

  /**
   * Functions
   */
  const initSwiper = () => {
    const swiperNode = document.querySelector(
      '[data-swiper-cart-recommendation]'
    );
    swiperEl = swiperUtil(swiperNode, {
      spaceBetween: 0,
      slidesPerView: 2.3,
      breakpoints: {
        768: {
          slidesPerView: 2.3,
        },
        1024: {
          slidesPerView: 2.3,
        },
      },
    });
  };

  const initObserver = () => {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendationsSection);

      const url = productRecommendationsSection.dataset.url;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector(
            '.product-recommendations'
          );

          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;

            // mount product cards
            const allProductCards =
              productRecommendationsSection.querySelectorAll(
                '[data-component="productCard"]'
              );
            allProductCards.forEach((card) => {
              document.dispatchEvent(
                new CustomEvent('shopify:section:load:product-card', {
                  detail: {
                    node: card,
                  },
                })
              );
            });
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    const productRecommendationsSection = document.querySelector(
      '.product-recommendations'
    );
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: '0px 0px 200px 0px',
    });

    observer.observe(productRecommendationsSection);
  };

  const getNewRecommendations = () => {
    initObserver();
    // reinit swiper
    if (swiperEl) swiperEl.destroy();
    swiperEl = null;
    initSwiper();
    swiperEl.update();
  };

  /**
   * Init
   */
  const init = () => {
    initSwiper();
    initObserver();

    document.addEventListener(
      'buy-it-with:load-recommendations',
      getNewRecommendations
    );
  };

  init();
};
